import { Component, Inject, OnInit } from "@angular/core";
import { BaseComponent, EProduct } from "src/app/@base/base.component";



@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent extends BaseComponent implements OnInit {

  public showProducts: boolean = false;

  constructor() {
    super();
    const user = this.getUser();
    this.showProducts = user && user.products && user.products.length > 0;
  }

  ngOnInit(): void {

    
  }



}
